module.exports = function() {
  return new Worker(__webpack_public_path__ + "08af485cd93277731953.worker.js");
};